export function formatDate(
  dateString,
  options = {
    year: "numeric",
    month: "long",
    day: "numeric",
  }
) {
  if (!dateString) return "";

  const date = new Date(dateString);

  return date.toLocaleDateString("en-US", options);
}
